import { Chat } from '@/config'
import { View, Text } from '@/components'
import { createStyles } from '@codeleap/styles'
import { useChannelStateContext } from 'stream-chat-react'

export const GroupMembersList = () => {
  const { channel } = useChannelStateContext()
  const { groupDescription } = Chat.Hooks.useGroupDescription(channel)

  if (!groupDescription) {
    return null
  }

  return (
    <View style={styles.container}>
      <Text
        text={groupDescription}
        style={['c2', styles.text]}
      />
    </View>
  )
}

const styles = createStyles(theme => ({
  container: {
    marginTop: theme.values.innerSpacing.Y * 0.5,
    width: '100%',
    overflow: 'hidden',
    flex: 1,
    minWidth: 0,
  },
  text: {
    color: theme.colors.textCaption,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
  },
}))

